import {URL_BASE} from "../../../../Globals.ts";
import {sendMessageToIde} from "../../../misc/envNameUtils.ts";

export const handleGiveFileForCodeApply = async (data: any, setDynamicStateObj: any, environment: string, vscode: any) => {
    try {
        const openFileContents = JSON.parse(data[0])[0];
        const codeBlock = data[1];

        const formattedOpenFileContents = `\`\`\`${openFileContents.languageName}\n${openFileContents.fileContents}\n\`\`\``;
        const formattedCodeBlock = `\`\`\`${openFileContents.languageName}\n${codeBlock}\n\`\`\``;

        const url = `${URL_BASE}/api/getCodeBlockApply`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ openFileContents: formattedOpenFileContents, formattedCodeBlock: formattedCodeBlock, rawCodeBlock: codeBlock })
        });
        if (!response.ok) {
            console.error('Network response was not ok');
            setDynamicStateObj({applyingCodeBlockId: null});
            return;
        }

        const responseData = await response.json();
        const {startLine, endLine, newContents} = responseData;

        sendMessageToIde(environment, vscode, "applyCodeBlock", [{startLine: startLine.toString(), endLine: endLine.toString(), newContents}]);

        setDynamicStateObj({applyingCodeBlockId: null});
    } catch (error) {
        console.error("Error in handleGiveFileForCodeApply:", error);
        setDynamicStateObj({applyingCodeBlockId: null});
    }
};